import TextWithEllipsis from '@/components/TextWithEllipsis';

const TextCell = ({ row, column, value }) => {
  const formattedValue = column.formatValue ? column.formatValue(value, row, column) : value;
  const style = column.getValueStyle ? column.getValueStyle({ value, row, column }) : undefined;

  return (
    <div className={`comp-grid-table-cell text-cell ${column.cellClassName || ''}`}>
      <TextWithEllipsis className="title" data-title={formattedValue}>
        <span style={style}>{formattedValue ?? '-'}</span>
      </TextWithEllipsis>
    </div>
  );
};

export default TextCell;
